module.exports = __webpack_public_path__ + "static/media/georgia-small.e1ed879c.jpg";